import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import colors from '../../../assets/theme/colors';

const stepThemes = {
  current: { circle: '#4EA48C', badgeBg: '#EDF3F0', badgeColor: '#60706A' },
  add: { circle: '#4EA48C', badgeBg: '#EDF3F0', badgeColor: '#60706A' },
  review: { circle: '#B97B43', badgeBg: '#FFF0E3', badgeColor: '#8B572A' },
  history: { circle: '#FFFFFF', circleColor: '#87928D', circleBorder: '#D8E0DC', badgeBg: '#EDF3F0', badgeColor: '#60706A' },
};

const MedicationManagerStepSection = ({
  step,
  title,
  description,
  badge,
  tone = 'current',
  last = false,
  children,
}) => {
  const theme = stepThemes[tone] || stepThemes.current;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '44px minmax(0, 1fr)', columnGap: { xs: 1, sm: 1.3 } }}>
      <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
        {!last ? (
          <Box sx={{ position: 'absolute', top: 40, bottom: -18, width: '1px', bgcolor: '#DDE4E0' }} />
        ) : null}
        <Box
          aria-hidden="true"
          sx={{
            width: 40,
            height: 40,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            position: 'relative',
            zIndex: 1,
            bgcolor: theme.circle,
            color: theme.circleColor || '#FFFFFF',
            border: theme.circleBorder ? `1px solid ${theme.circleBorder}` : 'none',
            fontSize: '0.98rem',
            fontWeight: 900,
          }}
        >
          {step}
        </Box>
      </Box>
      <Box sx={{ minWidth: 0, pb: last ? 0 : { xs: 2.7, sm: 3.2 } }}>
        <Stack direction="row" spacing={0.8} alignItems="center" sx={{ minHeight: 40, flexWrap: 'wrap', rowGap: 0.5 }}>
          <Typography sx={{ color: colors.landing.heroText, fontSize: { xs: '1.22rem', sm: '1.38rem' }, fontWeight: 900, lineHeight: 1.1 }}>
            {title}
          </Typography>
          {badge ? (
            <Box component="span" sx={{ px: 0.9, py: 0.3, borderRadius: '999px', bgcolor: theme.badgeBg, color: theme.badgeColor, fontSize: '0.72rem', fontWeight: 850, lineHeight: 1.2 }}>
              {badge}
            </Box>
          ) : null}
        </Stack>
        <Typography sx={{ mt: 0.25, color: colors.semantic.ink2, fontSize: '0.9rem', lineHeight: 1.45 }}>
          {description}
        </Typography>
        <Box sx={{ mt: 1.15 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default MedicationManagerStepSection;
